import React, { useEffect, useState, useRef } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Tooltip,
  ListItemIcon,
  Button,
} from "@mui/material";
import PropTypes from "prop-types";

import { useNavigate } from "react-router-dom";
import TtecLogo from "assets/images/ttecLogo.png";
import classes from "./Sidebar.module.css";
import {
  FmdBad as FmdBadIcon,
  FmdBadOutlined as FmdBadOutlinedIcon,
  PeopleAlt as PeopleAltIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  AccountBox as AccountBoxIcon,
  AccountBoxOutlined as AccountBoxOutlinedIcon,
  AssignmentTurnedIn,
  AssignmentTurnedInOutlined,
  CreateOutlined,
  MilitaryTech,
  MilitaryTechOutlined,
  Create as CreateIcon,
} from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import AddLocationAltOutlinedIcon from "@mui/icons-material/AddLocationAltOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import { useAuth } from "context/AuthContext";

function ObtMgmtDrawer({ index }) {
  const { roles } = useAuth();

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [showConfigList, setShowConfigList] = useState(false);
  const [hideToolTip, setHideToolTip] = useState(false);
  const [isASDGroup, setIsASDGroup] = useState(false);

  const drawerRef = useRef(null);

  useEffect(() => {
    const isOnlyASDGroup = roles.includes("ASD_Group") && roles.length === 1;
    setIsASDGroup(isOnlyASDGroup);
  }, [roles]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDrawer = (anchor, open) => {
    setOpen(open);
    setShowConfigList(false);
    if (anchor === "Milestones") {
      setDrawerTitle("Milestones");
      setShowConfigList(open);
    }
  };

  const handleClick = (anchor, close) => {
    setOpen(close);
    if (anchor === "CreateEditMilestone") {
      navigate(`/obtinfo/createMilestones`);
    } else if (anchor === "AssignMilestone") {
      navigate(`/obtinfo/assignMilestones`);
    }
  };

  const ObtMgmt = [
    {
      title: "Account Ownership",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/obtinfo/accountOwnership`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 1 ? (
            <div className={classes.selected}>
              <FmdBadIcon className={classes.blueIcon} />
            </div>
          ) : (
            <div className={classes.iconWrapper}>
              <FmdBadOutlinedIcon className={classes.whiteIcon} />
            </div>
          )}
        </IconButton>
      ),
    },
    {
      title: "Contact Roster",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/obtinfo/contactRoster`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 2 ? (
            <div className={classes.selected}>
              <PeopleAltIcon className={classes.blueIcon} />
            </div>
          ) : (
            <div className={classes.iconWrapper}>
              <PeopleAltOutlinedIcon className={classes.whiteIcon} />
            </div>
          )}
        </IconButton>
      ),
    },
    {
      title: "IDM Credential Tracking",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/obtinfo/idmCredentialTracking`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 3 ? (
            <div className={classes.selected}>
              <AccountBoxIcon className={classes.blueIcon} />
            </div>
          ) : (
            <div className={classes.iconWrapper}>
              <AccountBoxOutlinedIcon className={classes.whiteIcon} />
            </div>
          )}
        </IconButton>
      ),
    },
    {
      title: "Milestones",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            handleDrawer("Milestones", true);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 4 || index === 5 ? (
            <div className={classes.selected}>
              <MilitaryTech className={classes.blueIcon} />
            </div>
          ) : (
            <div className={classes.iconWrapper}>
              <MilitaryTechOutlined className={classes.whiteIcon} />
            </div>
          )}
        </IconButton>
      ),
    },
    {
      title: "Overture",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/obtinfo/overture`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 9 ? (
            <div className={classes.selected}>
              <PreviewOutlinedIcon className={classes.blueIcon} />
            </div>
          ) : (
            <div className={classes.iconWrapper}>
              <PreviewOutlinedIcon className={classes.whiteIcon} />
            </div>
          )}
        </IconButton>
      ),
    },
    {
      title: "OMT - Class Schedule",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/obtinfo/classSchedule`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 7 ? (
            <div className={classes.selected}>
              <CalendarMonthIcon className={classes.blueIcon} />
            </div>
          ) : (
            <div className={classes.iconWrapper}>
              <CalendarMonthIcon className={classes.whiteIcon} />
            </div>
          )}
        </IconButton>
      ),
    },
    {
      title: "OMT - Class Search",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/obtinfo/classSearch`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 8 ? (
            <div className={classes.selected}>
              <AddLocationAltOutlinedIcon className={classes.blueIcon} />
            </div>
          ) : (
            <div className={classes.iconWrapper}>
              <AddLocationAltOutlinedIcon className={classes.whiteIcon} />
            </div>
          )}
        </IconButton>
      ),
    },
  ];

  const filteredObtMgmt = isASDGroup
    ? ObtMgmt.filter(
        (item) =>
          item.title === "OMT - Class Schedule" ||
          item.title === "OMT - Class Search",
      )
    : ObtMgmt;

  return (
    <div className={classes.container}>
      <div className={classes.sidebar}>
        <Button
          className={classes.logoButton}
          onClick={() => {
            navigate(`/welcome`);
          }}
          aria-label="Navigate to Obt Info (Home)"
        >
          <img src={TtecLogo} className={classes.logo} alt={"Ttec Logo"} />
        </Button>

        <div className={classes.iconContainer}>
          {filteredObtMgmt.map((item, index) => (
            <Tooltip
              title={item.title}
              placement="right"
              key={item.title + index}
              arrow
              disableHoverListener={hideToolTip}
              disableFocusListener={hideToolTip}
            >
              {item.icon}
            </Tooltip>
          ))}
          <Drawer
            anchor="left"
            open={open}
            onClose={() => setOpen(false)}
            variant="persistent"
            sx={{
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                background: "#3299ff",
                left: "calc(5% - 30px)",
                width: 230,
                paddingLeft: 4,
                paddingTop: 2,
                paddingBottom: 2,
                paddingRight: 2,
              },
            }}
            ref={drawerRef}
          >
            <div>
              <IconButton onClick={() => setOpen(false)}>
                <p className={classes.drawerHeader}>{drawerTitle}</p>
              </IconButton>
              {showConfigList && (
                <List
                  sx={{
                    color: "white",
                    cursor: "pointer",
                    "& .css-10hburv-MuiTypography-root": {
                      fontFamily: "Urbanist, sans-serif",
                      fontWeight: "bold",
                      letterSpacing: "0.08em",
                    },
                  }}
                >
                  <ListItem
                    className={`${index === 4 ? classes.selectedSub : ""}`}
                    onClick={() => handleClick("CreateEditMilestone", false)}
                    sx={{
                      mb: 0.5,
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor: "white",
                        borderRadius: "4px",
                        color: "#3299ff",
                        "& .MuiListItemIcon-root svg": {
                          color: "#3299ff",
                          transition: "color 0.2s ease",
                        },
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 0 }}>
                      {index === 4 ? (
                        <CreateIcon
                          className={`${classes.blueIcon} ${classes.flippedIcon}`}
                        ></CreateIcon>
                      ) : (
                        <CreateOutlined
                          className={`${classes.whiteIcon} ${classes.flippedIcon}`}
                        ></CreateOutlined>
                      )}
                    </ListItemIcon>
                    <ListItemText sx={{ pl: 1 }} primary="Create and Edit" />
                  </ListItem>
                  <ListItem
                    className={`${index === 5 ? classes.selectedSub : ""}`}
                    onClick={() => handleClick("AssignMilestone", false)}
                    sx={{
                      mb: 0.5,
                      "&:hover": {
                        backgroundColor: "white",
                        borderRadius: "4px",
                        color: "#3299ff",
                        "& .MuiListItemIcon-root svg": {
                          color: "#3299ff",
                        },
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 0 }}>
                      {index === 5 ? (
                        <AssignmentTurnedIn
                          className={classes.blueIcon}
                        ></AssignmentTurnedIn>
                      ) : (
                        <AssignmentTurnedInOutlined
                          className={classes.whiteIcon}
                        ></AssignmentTurnedInOutlined>
                      )}
                    </ListItemIcon>
                    <ListItemText sx={{ pl: 1 }} primary="Assign Milestones" />
                  </ListItem>
                </List>
              )}
            </div>
          </Drawer>
        </div>
      </div>
    </div>
  );
}

ObtMgmtDrawer.propTypes = {
  index: PropTypes.number,
};

export default ObtMgmtDrawer;
